import { alpha } from 'vee-validate/dist/rules'
import Model, { Request } from '../model'
import Enum from '../enums'

import Images from './images'
import { CustomDomainStatus } from './settings'

export default class Location extends Model {
  static modelName () {
    return 'location'
  }

  objectID () {
    return this.idLocation
  }

  relations () {
    return {
      images: { type: Images },
      orderCreationDateDefault: { type: OrderCreationDateDefaultType },
      startDayOfWeek: { type: StartDayOfWeek },
      timeFormat: { type: TimeFormat },
      customDomainStatus: { type: CustomDomainStatus },
      receiptNumberType: { type: ReceiptNumberType },
      customerDisplayNameStyle: { type: CustomerDisplayNameStyle },
    }
  }

  static modelBaseURL () {
    return this.apiBaseURL() + '/v' + this.modelApiVersion() + '/settings/'
  }

  save () {
    const url = this.constructor.modelBaseURL() + this.constructor.modelName()
    const request = Request.jsonPost(url, this.requestJSON())

    const that = this
    return this.constructor.requestItem(request, this.constructor)
      .catch((err) => {
        throw err
      }).then((item) => {
        that.saturated = new Date()

        for (const key in item) {
          that[key] = item[key]
        }

        return that
      })
  }

  static loyaltyProgramBulkSet (type, status) {
    const url = this.modelBaseURL() + '/loyaltyProgramBulkSet'
    const request = {}

    request[type] = status ? 'on' : 'off'

    return this.requestSuccess(Request.post(url, JSON.stringify(request)))
  }

  get isCustomDomainStatusNone () {
    return this.customDomainStatus === CustomDomainStatus.none
  }

  get isCustomDomainStatusWaitingDNS () {
    return this.customDomainStatus === CustomDomainStatus.waitingDNS
  }

  get isCustomDomainStatusFailing () {
    return this.customDomainStatus === CustomDomainStatus.failing
  }

  get isCustomDomainStatusActive () {
    return this.customDomainStatus === CustomDomainStatus.active
  }

  get image () {
    if (this.images && this.images.square) {
      return this.images.square
    }

    return null
  }

  get initials () {
    return this.title.charAt(0).toUpperCase()
  }
}

export const OrderCreationDateDefaultType = new Enum({
  item: { value: 0, description: 'location.appointmentsDate' },
  now: { value: 1, description: 'general.todaysDate' },
})

export const ReceiptNumberType = new Enum({
  alphanum: { value: 0, description: 'location.alphanum' },
  sequential: { value: 1, description: 'location.sequential' },
})

export const StartDayOfWeek = new Enum({
  monday: { value: 1, description: 'datetime.days.monday.long' },
  tuesday: { value: 2, description: 'datetime.days.tuesday.long' },
  wednesday: { value: 3, description: 'datetime.days.wednesday.long' },
  thursday: { value: 4, description: 'datetime.days.thursday.long' },
  friday: { value: 5, description: 'datetime.days.friday.long' },
  saturday: { value: 6, description: 'datetime.days.saturday.long' },
  sunday: { value: 7, description: 'datetime.days.sunday.long' },
})

export const TimeFormat = new Enum({
  12: { value: 0, description: 'location.twelveHour' },
  24: { value: 1, description: 'location.twentyFourHour' },
})

export const CustomerDisplayNameStyle = new Enum({
  firstName: { value: 0, description: 'location.firstName' },
  firstLast: { value: 1, description: 'location.firstLast' },
  titleFirstLast: { value: 2, description: 'location.titleFirstLast' },
  titleLast: { value: 3, description: 'location.titleLast' },
  lastFirst: { value: 4, description: 'location.lastFirst' },
  lastFirstTitle: { value: 5, description: 'location.lastFirstTitle' },
})
